import { render, staticRenderFns } from "./ProductOrderTable.vue?vue&type=template&id=6712c3ca&scoped=true"
import script from "./ProductOrderTable.vue?vue&type=script&lang=js"
export * from "./ProductOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6712c3ca",
  null
  
)

export default component.exports